module.exports = "https://static.wanderu.com/static/media/train.b12332bf.svg";